export type IFormField = {
    FieldName: string;
    Validation: string;
    Required: boolean;
    Message: {
        empty: string;
        error: string
    };
    FieldType: string;
    Placeholder?:string;
    AllowRegex?: string; //regex to check on input or not
    Key:string;//key for state management - controlling the field
    MaxLength?: number;

}

export const GuestFormBuilder: Array<IFormField> = [
    {
        FieldName: "Name",
        Validation: "^[a-zA-Z]{2}[a-zA-Z\\s]*[a-zA-Z]{1}$",
        Required: true,
        Message: {
            empty: "This field is mandatory",
            error: "Invalid input"
        },
        FieldType:"string",
        Key:"Name",
        AllowRegex: "^[a-zA-Z ]*$",
        Placeholder:"Eg: Ramesh Khanna",
        MaxLength:50
    },
    {
        FieldName: "Email",
        Validation: "^[-_a-zA-Z0-9]+(\\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*(\\.[a-zA-Z]{2,4})$",
        Required: true,
        Message: {
            empty: "This field is mandatory",
            error: "Invalid input"
        },
        FieldType:"email",
        Key:"Email",
        Placeholder:"Eg: rameshk@gmail.com",
        MaxLength:50

    },
    {
        FieldName: "Mobile number",
        Validation: "^[6789]\\d{9}$",
        Required: true,
        Message: {
            empty: "This field is mandatory",
            error: "Invalid input"
        },
        FieldType:"text",
        Key:"MobileNumber",
        AllowRegex: "^[0-9]*$",
        Placeholder:"9988776655",
        MaxLength: 10
    }
];
